import React, { useEffect } from "react";
import "./App.scss";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useHistory
  // Link
} from "react-router-dom";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";

//components
import Layout from "./components/Layout";

//pages
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Sales from "./pages/Sales/Sales";

//Inventory
import Inventory from "./pages/Inventory/Inventory";
import InventoryAdjustment from "./pages/Inventory/InventoryAdjustment";
import InventoryAdjustmentInformation from "./pages/Inventory/InventoryAdjustmentInformation";
import InventoryAdjustmentHistory from "./pages/Inventory/InventoryAdjustmentHistory";
import InventoryAdjustmentHistoryView from "./pages/Inventory/InventoryAdjustmentHistoryView";
import InventoryAdjustmentHistoryEdit from "./pages/Inventory/InventoryAdjustmentHistoryEdit";
// context
import { CurrentPageProvider } from "./context/CurrentPageContext";

//Entity
import Entity from "./pages/Entity/Entity";
import CustomerInfo from "./pages/Entity/CustomerInfo/CustomerInfo";
import CustomerDetails from "./pages/Entity/CustomerInfo/CustomerDetails";

//Purchases
import Purchases from "./pages/Purchases/Purchases";
import PurchaseOrder from "./pages/Purchases/PurchaseOrder";
import PurchaseOrderInformation from "./pages/Purchases/PurchaseOrderInformation";
import PurchaseApproval from "./pages/Purchases/PurchaseApproval";
import PurchaseApprovalView from "./pages/Purchases/PurchaseApprovalView";
import PurchaseApprovalHistory from "./pages/Purchases/PurchaseApprovalHistory";
import PurchaseApprovalHistoryView from "./pages/Purchases/PurchaseApprovalHistoryView";
import PurchaseOrderEdit from "./pages/Purchases/PurchaseOrderEdit";
import PurchaseOrderReceipt from "./pages/Purchases/PurchaseOrderReceipt";
import PurchaseOrderReceiptForm from "./pages/Purchases/PurchaseOrderReceiptForm";
import PurchaseOrderPaymentForm from "./pages/Purchases/PurchaseOrderPaymentForm";
import PurchaseOrderReceive from "./pages/Purchases/PurchaseOrderReceive";
import PurchaseOrderReceiveInfo from "./pages/Purchases/PurchaseOrderReceiveInfo";
import PurchaseOrderReceiveView from "./pages/Purchases/PurchaseOrderReceiveView";
import PurchaseOrderReceiveBreakdown from "./pages/Purchases/PurchaseOrderReceiveBreakdown";

import PurchaseOrderReturn from "./pages/Purchases/PurchaseOrderReturn";
import PurchaseOrderPayment from "./pages/Purchases/PurchaseOrderPayment";

import PurchaseOrderReturnHistory from "./pages/Purchases/PurchaseOrderReturnHistory";
import PurchaseOrderTransactionHistory from "./pages/Purchases/PurchaseOrderTransactionHistory";

import PurchaseOrderReturnInformation from "./pages/Purchases/PurchaseOrderReturnInformation";
import PurchaseOrderReturnAllocate from "./pages/Purchases/PurchaseOrderReturnAllocate";
import PurchaseAllocateView from "./pages/Purchases/PurchaseAllocateView";
import PurchaseOrderReturnEdit from "./pages/Purchases/PurchaseOrderReturnEdit";
import PurchaseOrderDetailsReference from "./pages/Purchases/PurchaseOrderDetailsReference";
import CheckViewReference from "./pages/Accounts/CheckViewReference";

// Reports
import Reports from "./pages/Reports/Reports";
import ExpenseHistory from "./pages/Reports/ExpenseHistory/ExpenseHistory";
import ActivationCards from "./pages/Reports/ActivationCards/ActivationCards";
import CashierTurnOver from "./pages/Reports/CashierTurnOver/CashierTurnOver";
import PartnerProductPackage from "./pages/Reports/PartnerProductPackage/PartnerProductPackage";
import PurchasePayable from "./pages/Reports/PurchasePayable/PurchasePayable";
import RepeatOrderSummary from "./pages/Reports/RepeatOrderSummary/RepeatOrderSummary";
import SalesProduction from "./pages/Reports/SalesProduction/SalesProduction";
import VoidReport from "./pages/Reports/VoidReport/VoidReport";
import InventoryTransaction from "./pages/Reports/InventoryTransaction/InventoryTransaction";
import InventoryConsumption from "./pages/Reports/InventoryConsumption/InventoryConsumption";
import InventoryEnding from "./pages/Reports/InventoryEnding/InventoryEnding";
import SalesOrderListing from "./pages/Reports/SalesOrderListing/SalesOrderListing";
import PurchaseOrderListing from "./pages/Reports/PurchaseOrderListing/PurchaseOrderListing";
import PartnerRepeatOrderList from "./pages/Reports/PartnerRepeatOrderList/PartnerRepeatOrderList";
import DRPaymentDetails from "./pages/Reports/PartnerRepeatOrderList/DRPaymentDetails";
import PartnerItemReturnList from "./pages/Reports/PartnerItemReturnList/PartnerItemReturnList";
import DRReturnDetails from "./pages/Reports/PartnerItemReturnList/DRReturnDetails";
import GLTransactionHistory from "./pages/Reports/GLTransactionHistory/GLTransactionHistory";
import ExpenseReport from "./pages/Reports/ExpenseReport/ExpenseReport";
import TurnOverSummary from "./pages/Reports/TurnOverSummary/TurnOverSummary";
import JCPortalQuestRedeemedVouchers from "./pages/Reports/JCPortal/Quest/JCPortalQuestRedeemedVouchers";
// Sales

//Sales Order
import SalesOrder from "./pages/Sales/SalesOrder/SalesOrder";
import SalesOrderInformation from "./pages/Sales/SalesOrder/SalesOrderInformation";
import SalesOrderHistory from "./pages/Sales/SalesOrder/SalesOrderHistory";
import SalesOrderViewReference from "./pages/Sales/SalesOrder/SalesOrderViewReference";
import SalesOrderViewDetails from "./pages/Sales/SalesOrder/SalesOrderViewDetails";
import SalesReturn from "./pages/Sales/SalesOrder/SalesReturn";
import SalesReturnInformation from "./pages/Sales/SalesOrder/SalesReturnInformation";
import SalesReturnHistory from "./pages/Sales/SalesOrder/SalesReturnHistory";
import SalesReturnViewDetails from "./pages/Sales/SalesOrder/SalesReturnViewDetails";
import SalesReturnAllocate from "./pages/Sales/SalesOrder/SalesReturnAllocate";
import Collection from "./pages/Sales/SalesOrder/Collection";
import CollectionHistory from "./pages/Sales/SalesOrder/CollectionHistory";
import CollectionView from "./pages/Sales/SalesOrder/CollectionView";
import CollectionAllocate from "./pages/Sales/SalesOrder/CollectionAllocate";
import JcPortalSalesOrderHQ from "./pages/Sales/SalesOrder/JcPortalSalesOrderHQ";
import JcPortalSalesOrderHQView from "./pages/Sales/SalesOrder/JcPortalSalesOrderHQView";
import JcOnlineShopOrders from "./pages/Sales/SalesOrder/JcOnlineShopOrders";
import JcOnlineShopOrdersView from "./pages/Sales/SalesOrder/JcOnlineShopOrdersView";
import JcPortalPackageSales from "./pages/Sales/SalesOrder/JcPortalPackageSales";
import JcPortalPackageSalesView from "./pages/Sales/SalesOrder/JcPortalPackageSalesView";
import JCPortalUpgradeAccountPackageSales from "./pages/Sales/SalesOrder/JCPortalUpgradeAccountPackageSales";
import JCPortalUpgradeAccountPackageSalesView from "./pages/Sales/SalesOrder/JCPortalUpgradeAccountPackageSalesView";

//Package Sales
import PackageSales from "./pages/Sales/PackageSales/PackageSales";
import PackageSalesSetPackage from "./pages/Sales/PackageSales/PackageSalesSetPackage";
import PackageSalesInformation from "./pages/Sales/PackageSales/PackageSalesInformation";
import PackageSalesPayment from "./pages/Sales/PackageSales/PackageSalesPayment";
import PackageSalesItems from "./pages/Sales/PackageSales/PackagesSalesItems";
import PackageSalesItemsPrice from "./pages/Sales/PackageSales/PackageSalesItemsPrice";
import PackageSalesCodesOnly from "./pages/Sales/PackageSales/PackageSalesCodesOnly";
import PackageSalesCOMenu from "./pages/Sales/PackageSales/PackageSalesCOMenu";

//Settings
import Settings from "./pages/Settings/Settings";
import UserRole from "./pages/Settings/UserRole/UserRole";

import Void from "./pages/Settings/Void/Void";
import ContentNav from "./pages/Settings/ContentNav/ContentNav";
import MainNav from "./pages/Settings/MainNav/MainNav";
import JCPortalQuestVoucherRedemption from "./pages/Settings/JCPortal/Quest/JCPortalQuestVoucherRedemption";

//Accounts
import Accounts from "./pages/Accounts/Accounts";
import Check from "./pages/Accounts/Check";
import CheckTransactionHistory from "./pages/Accounts/CheckTransactionHistory";
import CheckApproval from "./pages/Accounts/CheckApproval";
import CheckApprovalView from "./pages/Accounts/CheckApprovalView";
import CheckView from "./pages/Accounts/CheckView";
import CheckClearView from "./pages/Accounts/CheckClearView";
import CashVoucher from "./pages/Accounts/CashVoucher";
import CashVoucherApproval from "./pages/Accounts/CashVoucherApproval";
import CashVoucherApprovalView from "./pages/Accounts/CashVoucherApprovalView";
import CashVoucherHistory from "./pages/Accounts/CashVoucherHistory";
import CashVoucherEdit from "./pages/Accounts/CashVoucherEdit";
import CashVoucherView from "./pages/Accounts/CashVoucherView";
import CashVoucherSettle from "./pages/Accounts/CashVoucherSettle";
import CashVoucherAllocate from "./pages/Accounts/CashVoucherAllocate";
import CashVoucherAllocatePO from "./pages/Accounts/CashVoucherAllocatePO";
import CashVoucherAllocatedView from "./pages/Accounts/CashVoucherAllocatedView";
import CashVoucherAllocateExpenses from "./pages/Accounts/CashVoucherAllocateExpenses";
import CashVoucherPrint from "./pages/Accounts/CashVoucherPrint";
import GLTransaction from "./pages/Accounts/GLTransaction";
import GLTransactionListing from "./pages/Accounts/GLTransactionListing";
import GLTransactionView from "./pages/Accounts/GLTransactionView";

import PackageSalesSummary from "./pages/Sales/PackageSales/PackageSalesSummary";
import PackageSalesSummaryDetails from "./pages/Sales/PackageSales/PackageSalesSummaryDetails";
import PackageSalesPackagesItems from "./pages/Sales/PackageSales/PackageSalesPackagesItem";
import BranchPackagePurchase from "./pages/Sales/PackageSales/BranchPackagePurchase";
import BranchPackageSalesSetPackage from "./pages/Sales/PackageSales/BranchPackageSalesSetPackage";
import BranchPackagePurchasePromo from "./pages/Sales/PackageSales/BranchPackagePurchasePromo";
import BranchPackageSalesPromo from "./pages/Sales/PackageSales/BranchPackageSalesPromo";
import ReceiveActivationCards from "./pages/Sales/PackageSales/ReceiveActivationCards";
import PackageSalesNavSettings from "./pages/Sales/PackageSales/PackageSalesNavSettings";
import PackageSalesNavSettingsFranchise from "./pages/Sales/PackageSales/PackageSalesNavSettingsFranchise";
import BranchPackagePurchaseOrder from "./pages/Sales/PackageSales/BranchPackagePurchaseOrder";
import SalesOrderViewReferenceEncode from "./pages/Sales/SalesOrder/SalesOrderViewReferenceEncode";
import BranchPurchaseOrderEncode from "./pages/Sales/PackageSales/BranchPurchaseOrderEncode";
import BranchPurchasePOPayment from "./pages/Sales/SalesOrder/BranchPurchasePOPayment";
import PurchaseReferenceView from "./pages/Purchases/PurchaseReferenceView";
// import UserAccess from "./pages/Settings/UserRole/UserAccess";
import PackageSalesView from "./pages/Sales/PackageSales/PackageSalesView";
import SupplierInfo from "./pages/Entity/Supplier/SupplierInfo";
import GlAccount from "./pages/Settings/GlAccount/GlAccount";
import InventoryEndingWithCost from "./pages/Reports/InventoryEndingWithCost/InventoryrEndingWithCost";
import WholesalerMenu from "./pages/Wholesaler/WholsalerMenu";
import WhosaleSet from "./pages/Wholesaler/WholesalesSet";
import WholesaleSet from "./pages/Wholesaler/WholesalesSet";
import WholesalesInformation from "./pages/Wholesaler/WholsalesInformation";
import WholesalePayment from "./pages/Wholesaler/WholesalePayment";
import WholesaleTransactionHistory from "./pages/Wholesaler/WholesaleTransactionHistory";
import WholesaleTransactionDetails from "./pages/Wholesaler/WholesaleTransactionDetails";
import CountryTagUpgrade from "./pages/Sales/SalesOrder/CountryTagUpgrade";
import CountryTagUpgradeDetails from "./pages/Sales/SalesOrder/CountryTagUpgradeDetails";
import ProductPackage from "./pages/Settings/ProductPackage/ProductPackage";
import ProductPackageView from "./pages/Settings/ProductPackage/ProductPackageView";
import ActivationCardsInfo from "./pages/Entity/ActivationCards/ActivationCardsInfo";
import BranchPackagePurchasePromoWholesale from "./pages/Sales/PackageSales/BranchPackagePurchasePromoWholesale";
import BranchPackageSalesPromoWholesale from "./pages/Sales/PackageSales/BranchPackageSalesPromoWholesale";
import CheckEdit from "./pages/Accounts/CheckEdit";
import FranchiseMenu from "./pages/Franchise/FranchiseMenu";
import FranchiseSet from "./pages/Franchise/FranchiseSet";
import FranchiseInformation from "./pages/Franchise/FranchiseInformation";
import FranchisePayment from "./pages/Franchise/FranchisePayment";
import FranchiseTransactionHistory from "./pages/Franchise/FranchiseTransactionHistory";
import FranchiseTransactionDetails from "./pages/Franchise/FranchiseTransactionDetails";
import WholesaleMenu from "./pages/Wholesaler/WholesaleMenu";
import FranchiseItemPrice from "./pages/Franchise/FranchiseItemsPrice";
import AccountUpgrade from "./pages/Sales/SalesOrder/AccountUpgrade";
import AccountUpgradeDetails from "./pages/Sales/SalesOrder/AccountUpgradeDetails";
import AccountUpgradePayment from "./pages/Sales/SalesOrder/AccountUpgradePayment";
import AccountUpgradePaymentDetails from "./pages/Sales/SalesOrder/AccountUpgradePaymentDetails";
import AccountUpgradePay from "./pages/Sales/SalesOrder/AccountUpgradePay";
import AccountUpgradeBranch from "./pages/Sales/SalesOrder/AccountUpgradeBranch";
import AccountUpgradeDelivery from "./pages/Sales/SalesOrder/AccountUpgradeDeilvery";
import AccountUpgradeDetailsDelivery from "./pages/Sales/SalesOrder/AccountUpgradeDetailsDelivery";
import InventoryLocationTransfer from "./pages/Inventory/InventoryLocationTransfer";
import InventoryLocationTransferView from "./pages/Inventory/InventoryLocationTransferView";

const theme = createTheme({
  typography: {
    fontFamily: ["Montserrat"].join(","),
  },
  palette: {
    primary: {
      main: "#339933",
    },
  },
});


function App() {
  //   const history = useHistory();
  //   useEffect(() => {
  //   const onStorage = (e) => {
  //     if (e.key === "logout") {
  //     localStorage.clear();
  //     sessionStorage.clear();

  //     window.location.replace(
  //       process.env.REACT_APP_BASE_NAME + "/login"
  //     );
  //     }
  //     console.log('u');
  //   };

  //   window.addEventListener("storage", onStorage);

  //   return () => {
  //     window.removeEventListener("storage", onStorage);
  //   };
  // }, [history]);

  return (
    <Router basename={process.env.REACT_APP_BASE_NAME}>
      <Switch>
        <Route exact path="/login" component={Login} />
        <CurrentPageProvider>
          <ThemeProvider theme={theme}>
            <Layout>
              <main>
                <Route exact path="/reports" component={Reports} />
                <Route exact path="/dashboard" component={Dashboard} />
                <Route
                  exact
                  path="/reports/gl-transaction-history"
                  component={GLTransactionHistory}
                />
                <Route
                  exact
                  path="/reports/expense-history"
                  component={ExpenseHistory}
                />
                <Route
                  exact
                  path="/reports/expense-report"
                  component={ExpenseReport}
                />
                <Route
                  exact
                  path="/reports/activation-cards"
                  component={ActivationCards}
                />
                <Route
                  exact
                  path="/reports/cashier-turnover"
                  component={CashierTurnOver}
                />
                <Route
                  exact
                  path="/reports/partnerproduct-package"
                  component={PartnerProductPackage}
                />
                <Route
                  exact
                  path="/reports/purchase-payable"
                  component={PurchasePayable}
                />
                <Route
                  exact
                  path="/reports/repeatorder-summary"
                  component={RepeatOrderSummary}
                />
                <Route
                  exact
                  path="/reports/sales-production"
                  component={SalesProduction}
                />
                <Route
                  exact
                  path="/reports/void-report"
                  component={VoidReport}
                />
                <Route
                  exact
                  path="/reports/inventory-consumption"
                  component={InventoryConsumption}
                />
                <Route
                  exact
                  path="/reports/inventory-ending"
                  component={InventoryEnding}
                />
                <Route
                  exact
                  path="/reports/inventory-ending-cost"
                  component={InventoryEndingWithCost}
                />
                <Route
                  exact
                  path="/reports/item-return-list"
                  component={PartnerItemReturnList}
                />
                <Route
                  exact
                  path="/reports/item-return-list/return-details/:drretno"
                  component={DRReturnDetails}
                />
                <Route
                  exact
                  path="/reports/sales-order-listing"
                  component={SalesOrderListing}
                />
                <Route
                  exact
                  path="/reports/purchase-order-listing"
                  component={PurchaseOrderListing}
                />
                <Route
                  exact
                  path="/reports/repeat-order-list"
                  component={PartnerRepeatOrderList}
                />
                <Route
                  exact
                  path="/reports/repeat-order-list/payment-details/:drpayment"
                  component={DRPaymentDetails}
                />
                <Route
                  exact
                  path="/reports/inventory-transaction"
                  component={InventoryTransaction}
                />
                <Route
                  exact
                  path="/reports/turnover-summary"
                  component={TurnOverSummary}
                />
                <Route
                  exact
                  path="/reports/jc-portal-quest-redeemed-vouchers"
                  component={JCPortalQuestRedeemedVouchers}
                />
                <Route exact path="/entity" component={Entity} />
                <Route
                  exact
                  path="/entity/customer-info"
                  component={CustomerInfo}
                />
                <Route
                  exact
                  path="/entity/customer-details/:id"
                  component={CustomerDetails}
                />
                <Route
                  exact
                  path="/entity/supplier-info"
                  component={SupplierInfo}
                />
                <Route exact path="/sales" component={Sales} />
                <Route exact path="/sales/sales-order" component={SalesOrder} />
                <Route
                  exact
                  path="/sales/sales-order-information/:shippingId/:warehouseId/:idNo/:trantype/:selectedDate"
                  component={SalesOrderInformation}
                />
                <Route
                  exact
                  path="/sales/sales-order-history"
                  component={SalesOrderHistory}
                />
                <Route
                  exact
                  path="/sales/sales-order-history-view-ref/:drno/:useridNo"
                  component={SalesOrderViewReference}
                />
                <Route
                  exact
                  path="/sales/sales-order-history-view-details/:drno/:useridNo"
                  component={SalesOrderViewDetails}
                />
                <Route
                  exact
                  path="/sales/sales-return"
                  component={SalesReturn}
                />
                <Route
                  exact
                  path="/sales/sales-return-information/:shippingId/:warehouseId/:idNo/:selectedDate"
                  component={SalesReturnInformation}
                />
                <Route
                  exact
                  path="/sales/sales-return-history"
                  component={SalesReturnHistory}
                />
                <Route
                  exact
                  path="/sales/sales-return-history-view/:drretno/:useridNo"
                  component={SalesReturnViewDetails}
                />
                <Route
                  exact
                  path="/sales/sales-return-history-allocate/:drretno/:useridNo"
                  component={SalesReturnAllocate}
                />
                <Route exact path="/sales/collection" component={Collection} />
                <Route
                  exact
                  path="/sales/collection-history"
                  component={CollectionHistory}
                />
                <Route
                  exact
                  path="/sales/country-tag-upgrade"
                  component={CountryTagUpgrade}
                />
                <Route
                  exact
                  path="/sales/country-tag-upgrade-view/:id/:useridNo"
                  component={CountryTagUpgradeDetails}
                />
                <Route
                  exact
                  path="/sales/collection-history-view/:drpayno/:useridNo"
                  component={CollectionView}
                />
                <Route
                  exact
                  path="/sales/collection-history-allocate/:drpayno/:useridNo"
                  component={CollectionAllocate}
                />
                <Route
                  exact
                  path="/sales/jcportalsales"
                  component={JcPortalSalesOrderHQ}
                />
                <Route
                  exact
                  path="/sales/jcportalsales-view/:idno/:sono/:flag"
                  component={JcPortalSalesOrderHQView}
                />
                <Route
                  exact
                  path="/sales/jconlineshop"
                  component={JcOnlineShopOrders}
                />
                <Route
                  exact
                  path="/sales/jconlineshop-view/:drno/:flag"
                  component={JcOnlineShopOrdersView}
                />
                <Route
                  exact
                  path="/sales/jcpackagesales"
                  component={JcPortalPackageSales}
                />
                <Route
                  exact
                  path="/sales/jcpackagesales-view/:transaction_no/:flag"
                  component={JcPortalPackageSalesView}
                />
                <Route
                  exact
                  path="/sales/jcportalupgrade"
                  component={JCPortalUpgradeAccountPackageSales}
                />
                <Route
                  exact
                  path="/sales/jcportalupgrade-view/:transaction_no/:flag"
                  component={JCPortalUpgradeAccountPackageSalesView}
                />
                <Route
                  exact
                  path="/sales/sales-order-history-view-ref-encode/:drno/:useridNo/:branchtype"
                  component={SalesOrderViewReferenceEncode}
                />
                <Route
                  exact
                  path="/sales/branchpurchaseorderencode/:recid"
                  component={BranchPurchaseOrderEncode}
                />
                <Route
                  exact
                  path="/sales/branchpopayment/"
                  component={BranchPurchasePOPayment}
                />
                <Route exact path="/purchases" component={Purchases} />
                <Route
                  exact
                  path="/purchases/purchases-order"
                  component={PurchaseOrder}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-information/:supid/:warehouseid/:delivery_date"
                  component={PurchaseOrderInformation}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-approval"
                  component={PurchaseApproval}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-approval-view/:pono/:branchidno"
                  component={PurchaseApprovalView}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-approval-history"
                  component={PurchaseApprovalHistory}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-approval-history-view/:pono/:branchidno"
                  component={PurchaseApprovalHistoryView}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-edit/:pono/:branchidno"
                  component={PurchaseOrderEdit}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-return/"
                  component={PurchaseOrderReturn}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-return-transaction-history/"
                  component={PurchaseOrderReturnHistory}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-return-information/:supid/:warehouseid/:delivery_date"
                  component={PurchaseOrderReturnInformation}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-return-allocate/:poretno/:branchidno"
                  component={PurchaseOrderReturnAllocate}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-allocate-view/:poretno/:branchidno"
                  component={PurchaseAllocateView}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-return-edit/:poretno/:branchidno"
                  component={PurchaseOrderReturnEdit}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-details-reference/:pono/:branchidno"
                  component={PurchaseOrderDetailsReference}
                />

                <Route
                  exact
                  path="/purchases/purchases-order-receive"
                  component={PurchaseOrderReceive}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-receive-info/:pono/:branchidno"
                  component={PurchaseOrderReceiveInfo}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-receive-view/:pono/:branchidno"
                  component={PurchaseOrderReceiveView}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-reference-view/:pono/:branchidno"
                  component={PurchaseReferenceView}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-receive-view/:pono/:branchidno/:itemid"
                  component={PurchaseOrderReceiveBreakdown}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-receipt"
                  component={PurchaseOrderReceipt}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-receipt-form/:pono/:branchidno"
                  component={PurchaseOrderReceiptForm}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-transaction-history"
                  component={PurchaseOrderTransactionHistory}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-payment"
                  component={PurchaseOrderPayment}
                />
                <Route
                  exact
                  path="/purchases/purchases-order-payment-form/:chkno/:branchidno"
                  component={PurchaseOrderPaymentForm}
                />
                {/*  */}
                <Route exact path="/settings" component={Settings} />
                <Route exact path="/settings/user-role" component={UserRole} />
                <Route
                  exact
                  path="/settings/gl-accounts"
                  component={GlAccount}
                />
                {/* <Route exact path="/settings/user-access" component={UserAccess}/> */}

                <Route exact path="/settings/void-record" component={Void} />
                <Route
                  exact
                  path="/settings/content-nav"
                  component={ContentNav}
                />
                <Route exact path="/settings/main-nav" component={MainNav} />
                <Route
                  exact
                  path="/settings/jc-portal-quest-voucher-redemption"
                  component={JCPortalQuestVoucherRedemption}
                />
                {/*  */}
                <Route exact path="/account" component={Accounts} />
                <Route exact path="/account/check" component={Check} />
                <Route
                  exact
                  path="/account/check-transaction-history"
                  component={CheckTransactionHistory}
                />
                <Route
                  exact
                  path="/account/check-approval"
                  component={CheckApproval}
                />
                <Route
                  exact
                  path="/account/check-edit/:chkno/:branchidno"
                  component={CheckEdit}
                />
                <Route
                  exact
                  path="/account/check-approval-history-view/:chkno"
                  component={CheckApprovalView}
                />
                <Route
                  exact
                  path="/account/check-clear-view/:chkno/:branchidno"
                  component={CheckClearView}
                />
                <Route
                  exact
                  path="/account/check-view/:chkno/:branchidno"
                  component={CheckView}
                />
                <Route
                  exact
                  path="/account/check-view-reference/:chkno/:branchidno"
                  component={CheckViewReference}
                />
                <Route
                  exact
                  path="/account/cash-voucher"
                  component={CashVoucher}
                />
                <Route
                  exact
                  path="/account/cash-voucher-approval"
                  component={CashVoucherApproval}
                />
                <Route
                  exact
                  path="/account/cash-voucher-approval-view/:cvno/:branchidno"
                  component={CashVoucherApprovalView}
                />
                <Route
                  exact
                  path="/account/cash-voucher-approval-view/:cvno/:branchidno/r"
                  component={CashVoucherApprovalView}
                />
                <Route
                  exact
                  path="/account/cash-voucher-transaction-history"
                  component={CashVoucherHistory}
                />
                <Route
                  exact
                  path="/account/cash-voucher-edit/:cvno/:branchidno"
                  component={CashVoucherEdit}
                />
                <Route
                  exact
                  path="/account/cash-voucher-view/:cvno/:branchidno"
                  component={CashVoucherView}
                />
                <Route
                  exact
                  path="/account/cash-voucher-settle/:cvno/:branchidno"
                  component={CashVoucherSettle}
                />
                <Route
                  exact
                  path="/account/cash-voucher-allocate/:cvno/:branchidno"
                  component={CashVoucherAllocate}
                />
                <Route
                  exact
                  path="/account/cash-voucher-allocate-p/:cvno/:branchidno/:supplierId"
                  component={CashVoucherAllocatePO}
                />
                <Route
                  exact
                  path="/account/cash-voucher-view-allocated/:cvno/:branchidno/"
                  component={CashVoucherAllocatedView}
                />
                <Route
                  exact
                  path="/account/cash-voucher-allocate-e/:cvno"
                  component={CashVoucherAllocateExpenses}
                />
                <Route
                  exact
                  path="/account/cash-voucher-print/:cvno/:branchidno"
                  component={CashVoucherPrint}
                />
                <Route
                  exact
                  path="/account/gl-transaction"
                  component={GLTransaction}
                />
                <Route
                  exact
                  path="/account/gl-transaction-history"
                  component={GLTransactionListing}
                />
                <Route
                  exact
                  path="/account/gl-transaction-history-view/:glid"
                  component={GLTransactionView}
                />
                {/*  */}
                <Route exact path="/inventory" component={Inventory} />
                <Route
                  exact
                  path="/inventory/inventory-adjustment"
                  component={InventoryAdjustment}
                />
                <Route
                  exact
                  path="/inventory/inventory-adjustment-information/:warehouseid/:type/:trandate"
                  component={InventoryAdjustmentInformation}
                />
                <Route
                  exact
                  path="/inventory/inventory-adjustment-history"
                  component={InventoryAdjustmentHistory}
                />
                <Route
                  exact
                  path="/inventory/inventory-adjustment-history-view/:adjno/:branchidno"
                  component={InventoryAdjustmentHistoryView}
                />
                <Route
                  exact
                  path="/inventory/inventory-adjustment-history-edit/:adjno/:branchidno"
                  component={InventoryAdjustmentHistoryEdit}
                />
                  <Route
                  exact
                  path="/inventory/inventory-location-transfer"
                  component={InventoryLocationTransfer}
                />
                                <Route
                  exact
                  path="/inventory/inventory-location-transfer-view/:iltno/:branchidno"
                  component={InventoryLocationTransferView}
                />
                {/*  */}
                <Route exact path="/package-sales" component={PackageSales} />
                <Route
                  exact
                  path="/package-sales-setpackage/:navid/:navname"
                  component={PackageSalesSetPackage}
                />
                <Route
                  exact
                  path="/package-sales-information/"
                  component={PackageSalesInformation}
                />
                <Route
                  exact
                  path="/package-sales-payment/"
                  component={PackageSalesPayment}
                />
                <Route
                  exact
                  path="/package-sales-item/"
                  component={PackageSalesItems}
                />
                <Route
                  exact
                  path="/package-sales-franchise/"
                  component={PackageSalesItemsPrice}
                />
                <Route
                  exact
                  path="/package-sales-summary/:iscodesonly"
                  component={PackageSalesSummary}
                />
                <Route
                  exact
                  path="/package-sales-summary-details/"
                  component={PackageSalesSummaryDetails}
                />
                <Route
                  exact
                  path="/package-sales-packagesitem/"
                  component={PackageSalesPackagesItems}
                />
                <Route
                  exact
                  path="/branch-package-purchase/"
                  component={BranchPackagePurchase}
                />
                <Route
                  exact
                  path="/branch-package-purchase-firststep/"
                  component={BranchPackageSalesSetPackage}
                />
                <Route
                  exact
                  path="/branch-package-purchase-promo/"
                  component={BranchPackagePurchasePromo}
                />
                <Route
                  exact
                  path="/branch-package-purchasepromo-firststep/"
                  component={BranchPackageSalesPromo}
                />
                <Route
                  exact
                  path="/receive-activationcards"
                  component={ReceiveActivationCards}
                />
                <Route
                  exact
                  path="/packagesalesnav-settings"
                  component={PackageSalesNavSettings}
                />
                <Route
                  exact
                  path="/packagesalesnav-settings-franchise"
                  component={PackageSalesNavSettingsFranchise}
                />
                <Route
                  exact
                  path="/branch-purchase-order/"
                  component={BranchPackagePurchaseOrder}
                />
                <Route
                  exact
                  path="/package-sales-codesonly"
                  component={PackageSalesCodesOnly}
                />
                <Route
                  exact
                  path="/package-sales-co-menu/:nav_code/:nav_name"
                  component={PackageSalesCOMenu}
                />
                <Route
                  exact
                  path="/package-sales-view/:idno"
                  component={PackageSalesView}
                />
                 <Route exact path="/WholesaleMenu" component={WholesaleMenu} />
                <Route exact path="/Wholesale" component={WholesalerMenu} />
                <Route
                  exact
                  path="/Wholesale-set/:package_name"
                  component={WholesaleSet}
                />
                <Route
                  exact
                  path="/wholesales-information/"
                  component={WholesalesInformation}
                />
                <Route
                  exact
                  path="/wholesales-payment/"
                  component={WholesalePayment}
                />
                <Route
                  exact
                  path="/wholesale-transaction-history/"
                  component={WholesaleTransactionHistory}
                />
                <Route
                  exact
                  path="/wholesale-transaction-details/:idno/:eligible/:fs"
                  component={WholesaleTransactionDetails}
                />
                 <Route exact path="/Franchise" component={FranchiseMenu} />
                <Route
                  exact
                  path="/Franchise-set/:package_name"
                  component={FranchiseSet}
                />
                <Route
                  exact
                  path="/Franchise-information/"
                  component={FranchiseInformation}
                />
                                <Route
                  exact
                  path="/Franchise-franchise/"
                  component={FranchiseItemPrice}
                />
                <Route
                  exact
                  path="/Franchise-payment/"
                  component={FranchisePayment}
                />
                <Route
                  exact
                  path="/Franchise-transaction-history/"
                  component={FranchiseTransactionHistory}
                />
                <Route
                  exact
                  path="/Franchise-transaction-details/"
                  component={FranchiseTransactionDetails}
                />
                                <Route
                  exact
                  path="/branch-package-purchase-promo-wholesale/"
                  component={BranchPackagePurchasePromoWholesale}
                />
                              <Route
                  exact
                  path="/branch-package-purchasepromowholesale-firststep/"
                  component={BranchPackageSalesPromoWholesale}
                />
                <Route
                  exact
                  path="/settings/product-package"
                  component={ProductPackage}
                />
                <Route
                  exact
                  path="/settings/product-package-view/:idno"
                  component={ProductPackageView}
                />
                             <Route
                  exact
                  path="/entity/activation-cards-info"
                  component={ActivationCardsInfo}
                />
                <Route
                  exact
                  path="/sales/account-upgrade"
                  component={AccountUpgrade}
                />
                                <Route
                  exact
                  path="/sales/account-upgrade-branch"
                  component={AccountUpgradeBranch}
                />
                                <Route
                  exact
                  path="/sales/account-upgrade-delivery"
                  component={AccountUpgradeDelivery}
                />
                                <Route
                  exact
                  path="/sales/account-upgrade-payment"
                  component={AccountUpgradePayment}
                />
                                <Route
                  exact
                  path="/sales/account-upgrade-payment-view/:mainRef/:id/:useridNo"
                  component={AccountUpgradePaymentDetails}
                />
                                                <Route
                  exact
                  path="/sales/account-upgrade-pay"
                  component={AccountUpgradePay}
                />
                <Route
                  exact
                  path="/sales/account-upgrade-view/:id/:useridNo"
                  component={AccountUpgradeDetails}
                />
                <Route
                  exact
                  path="/sales/account-upgrade-view-delivery/:id/:useridNo"
                  component={AccountUpgradeDetailsDelivery}
                />
              </main>
            </Layout>
          </ThemeProvider>
        </CurrentPageProvider>
      </Switch>
    </Router>
  );
}
export default App;
